/* eslint-disable no-restricted-globals */
import { useState } from 'react';
import { Field } from '../../components/UI';
import { api } from '../../lib/api';
import { Link, navigate } from '../../lib/router';

export function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError('');

    try {
      const user = await api.login(email, password);
      onLogin(user);
      const next = new URLSearchParams(location.search).get('next');
      navigate(next?.startsWith('/merchant') ? next : '/merchant');
    } catch {
      setError('We couldn’t sign you in. Check your email and password and try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <section className="login-story" aria-label="About LoyalQR">
        <span className="login-story-brand">LoyalQR.sg</span>
        <div>
          <h1>Turn first-time customers into regulars.</h1>
          <p>Create a simple return voucher, display one counter QR, and redeem it when customers come back.</p>
        </div>
        <small>Built for independent businesses in Singapore.</small>
      </section>

      <section className="login-panel">
        <form onSubmit={submit}>
          <Link className="login-back-link" to="/">
            <svg viewBox="0 0 20 20" aria-hidden="true">
              <path d="m11.75 4.75-5.25 5.25 5.25 5.25M7 10h7" />
            </svg>
            Back to LoyalQR.sg
          </Link>
          <Link className="login-logo-link" to="/" aria-label="LoyalQR.sg home">
            <img
              className="login-logo"
              src="/logo-v2-wordmark.png"
              width="615"
              height="165"
              alt="LoyalQR.sg"
            />
          </Link>
          <div className="login-heading">
            <h1>Welcome back</h1>
            <p>Sign in to manage your LoyalQR account.</p>
          </div>
          {error && (
            <div className="alert error" role="alert">
              {error}
            </div>
          )}
          <Field label="Business email">
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </Field>
          <div className="login-password-field">
            <Field label="Password">
              <input
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                autoComplete="current-password"
                required
              />
            </Field>
            <Link className="login-forgot-link" to="/contact">
              Forgot your password? Contact us
            </Link>
          </div>
          <button className="button primary wide" disabled={busy}>
            {busy ? 'Signing in…' : 'Sign in'}
          </button>
          <div className="login-new-business">
            <div>
              <strong>New to LoyalQR?</strong>
              <span>Tell us about your business and we’ll help you get started.</span>
            </div>
            <Link className="login-contact-link" to="/contact">Talk to our team</Link>
          </div>
        </form>
      </section>
    </main>
  );
}
